// extracted by mini-css-extract-plugin
module.exports = {"flipIconContainer":"FlippyIcon_flipIconContainer__2rtRT","isFlipping":"FlippyIcon_isFlipping__DJRQc","flip":"FlippyIcon_flip__d0_wz"};